<script setup>
const tarjetas = [
  {
    clase: "flex-1_2",
    contenido: `La pandemia de Covid-19, causada por el <strong>virus SARS-CoV-2, representa un problema de salud pública sin precedentes</strong>en los últimos años.`,
  },
  {
    clase: "flex-1_2",
    contenido: `Existen múltiples variantes del virus en el mundo, por ello, <strong>conocer y analizar</strong> las que circulan en México <strong>puede ayudar a minimizar los contagios</strong> y contribuir al desarrollo de nuevas vacunas.`,
  },
  {
    clase: "flex-1_3",
    contenido: `<strong>Mientras más personas estén vacunadas</strong>, se generarán más defensas en la población para hacer frente a la enfermedad y, por tanto, <strong>mayores probabilidades de recuperación</strong>.`,
  },
  {
    clase: "flex-1_3",
    contenido: `<strong>Aumentar el porcentaje de vacunación</strong> contribuye a disminuir el número de variantes y a <strong>reducir el riesgo de contagios</strong> en nuestro país.`,
  },
  {
    clase: "flex-1_3",
    contenido: `El Conahcyt conformó un equipo de trabajo para el <strong>análisis, visualización, actualización y publicación de las variantes</strong>, así como para darles seguimiento regional en México.`,
  },
];
</script>

<template>
  <div class="container main">
    <h1 class="titulo m-y-1 m-t-3-md">Contexto</h1>

    <div class="tablero-contexto m-b-2">
      <div v-for="(tarjeta, idx) in tarjetas" :key="`tarjeta-${idx}`" :class="tarjeta.clase">
        <div class="numeracion">{{ idx + 1 }}</div>
        <picture class="picture">
          <source
            media="(min-width:769px)"
            :srcset="require(`@/assets/img/contexto/Seccion-${idx + 1}.png`)"
          />
          <source
            media="(max-width:768px)"
            :srcset="require(`@/assets/img/contexto/Seccion${idx + 1}-Movil.png`)"
          />
          <img :src="require(`@/assets/img/contexto/Seccion-${idx + 1}.png`)" />
        </picture>
        <p v-html="tarjeta.contenido" />
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.tablero-contexto {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;

  .numeracion {
    position: absolute;
    top: $gap * 0.5;
    left: $gap * 0.5;
    font-size: 22px;
    font-weight: bold;
    text-align: center;
    line-height: 40px;
    color: #c45016;
    background-color: rgba(255, 255, 255, 0.8);
    border: 1px solid #efb287;
    border-radius: 50%;
    width: 40px;
    height: 40px;
    overflow: hidden;
  }

  img {
    max-width: 100%;
  }

  p {
    padding: 0 $gap;
  }

  .flex-1_2,
  .flex-1_3 {
    flex: 1 0 100%;
    margin-bottom: $gap;
    border: 1px solid #efb287;
    border-radius: 10px;
    overflow: hidden;
    position: relative;
    margin-bottom: $gap;
  }

  @media (min-width: map-get($media-queries-limit, "mobile")) {
    .flex-1_2 {
      flex: 1 0 50%;
      max-width: calc(50% - #{$gap * 0.5});
    }
    .flex-1_3 {
      flex: 1 0 33%;
      max-width: calc(33% - #{$gap * 0.5});
    }
  }
}

.a11y-simplificada {
  .tablero-contexto {
    flex-direction: column;

    .flex-1_2,
    .flex-1_3 {
      display: flex;
      flex-direction: row;
      @media (min-width: map-get($media-queries-limit, "mobile")) {
        min-width: 600px;
        max-width: 600px;
      }
    }

    .picture {
      display: none;
    }

    .numeracion {
      position: relative;
      min-width: 40px;
    }
  }
}
</style>
